module.exports = __webpack_public_path__ + "static/img/Bachelor_010537.738f105.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010537.jpg
// module id = 184
// module chunks = 0